class ShopTheLookProducts extends HTMLElement {
  connectedCallback() {
    this.cartDrawerElement = document.querySelector('cart-drawer');
    this.errorMessageElement = this.querySelector('[data-error]');

    this.addEventListener('click', this.handleClick.bind(this));
    this.addEventListener('change', this.handleChange.bind(this));
  }

  handleClick(event) {
    const button = event.target.closest('[data-add]');
    if (!button) return;
    event.preventDefault();

    const items = button.hasAttribute('data-add-all')
      ? [...this.querySelectorAll('[data-look-item][data-available="true"]')]
      : [button.closest('[data-look-item]')];

    this.addToCart(items, button);
  }

  handleChange(event) {
    if (!event.target.matches('select[name="id"]')) return;
    event.target.closest('[data-look-item]').classList.remove('is-missing');
    if (!this.querySelector('[data-look-item].is-missing')) this.showErrorMessage();
  }

  addToCart(items, button) {
    const missing = items.filter((item) => !item.querySelector('[name="id"]').value);
    this.querySelectorAll('[data-look-item].is-missing').forEach((item) => item.classList.remove('is-missing'));

    if (missing.length) {
      missing.forEach((item) => item.classList.add('is-missing'));
      this.showErrorMessage(this.dataset.missingMessage);
      const firstSelect = missing[0].querySelector('select');
      if (firstSelect) {
        missing[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstSelect.focus({ preventScroll: true });
      }
      return;
    }

    const payload = {
      items: items.map((item) => ({ id: Number(item.querySelector('[name="id"]').value), quantity: 1 })),
    };

    if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType != 'drawer') {
      FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { ...payload } });
      return;
    }

    this.showErrorMessage();
    this.toggleButtonLoading(button, true);

    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
    );

    const body = JSON.stringify({ ...payload, sections: sectionsToBundle, section_url: window.location.pathname });

    fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then(async (parsedState) => {
        if (parsedState.status) {
          this.showErrorMessage(parsedState.description);
          return;
        }

        const cartJson = await (await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })).json();
        cartJson['sections'] = parsedState['sections'];

        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
        document.dispatchEvent(new CustomEvent('product-ajax:added', { detail: { product: parsedState } }));
        this.cartDrawerElement && this.cartDrawerElement.show(button);
      })
      .catch((error) => console.error(error))
      .finally(() => this.toggleButtonLoading(button, false));
  }

  showErrorMessage(errorMessage = false) {
    if (!this.errorMessageElement) {
      errorMessage && alert(errorMessage);
      return;
    }
    this.errorMessageElement.hidden = !errorMessage;
    if (errorMessage) this.errorMessageElement.textContent = errorMessage;
  }

  toggleButtonLoading(button, status) {
    button.classList.toggle('btn--loading', status);
    button.toggleAttribute('disabled', status);
  }
}
customElements.define('shop-the-look-products', ShopTheLookProducts);
